<template>
<div>
  <div>
    <h3>{{ msg.header }}</h3>
    <hr/>
    <div :class="['alert', `alert-${msg.message.color}`]" role="alert">{{ msg.message.text }}</div>
    <router-link :to="{ name: msg.routename }"><button class="card-1 btn btn-primary btn-lg btn-block">{{ msg.routemsg }}</button></router-link>
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  props: { 
    msg: {
      type: Object,
      default: () => {
        return  {
          header: "DashBoard",
          message: {
            text: "Please Navigate to the Home Page",
            color: "warning",
          },
          routename: "home",
          routemsg: "Go to Home Page"
        }
      }
    }
  },
}
</script>